import { toast } from "react-toastify";
import { 
    handleStoreActiveSessions, 
    handleStoreAllPermissions, 
    handleStoreAllRoles, 
    handleStoreCreateRoleRes, 
    handleStoreDeleteRoleRes, 
    handleStoreDeleteUserRes, 
    handleStoreEditRoleRes, 
    handleStoreGroupRoles, 
    handleStoreRoleMasterData, 
    handleStoreUpdateRoleRes, 
    handleStoreUpdateUserResponse, 
    handleStoreUserListByDepartment, 
    handleStoreUserMasterData, 
    hasError, 
    startLoading, 
    stopLoading 
} from "../redux/slices/roleMasterSlice";
import ServicesManagerAPICall from "../services/ServicesManagerAPICall";
import { method, paths } from "../services/ServiceConstants";
import { mapLOBMaster } from "../utils/MastersMapping";
import { checkNullValue } from "../utils/Util";

export const getRoleMasterApi = (selectedFilter: any, limitSelected: number, limitStart: number) => {
    const body = {
        name: selectedFilter?.roleName?.trim(),
        id: selectedFilter?.roleId?.trim(),
        status: selectedFilter?.roleStatus?.label ==='Active' ? true : 
                selectedFilter?.roleStatus?.label ==='Inactive' ? false : 
                'ALL',
        offset: limitStart,
        limit: limitSelected,
        lobId: selectedFilter?.lineOfBusiness?.value ?? ''
    }
    return async (dispatch: any) => {
        dispatch(startLoading());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GET_ROLES,
                body,
                false
            ).then(async (res: any) => {
                if (res !== null && res?.groups?.length > 0 ) {
                    dispatch(handleStoreRoleMasterData(res));
                }
                else{
                    dispatch(handleStoreRoleMasterData([]));
                }
            }, (err: any) => {
                dispatch(stopLoading());
                dispatch(handleStoreRoleMasterData([]));
            })
        } catch (error: any) {
            dispatch(hasError(error));
        }

    }
}


export const getAllPermissions = () => {
    return async (dispatch: any) => {
        dispatch(startLoading());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GET_PERMISSIONS,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null && res?.length > 0 ) {
                    dispatch(handleStoreAllPermissions(res));
                }
                else{
                    dispatch(handleStoreAllPermissions([]));
                }
            }, (err: any) => {
                toast.error(err.data);
                dispatch(stopLoading());
                dispatch(handleStoreAllPermissions([]));
            })
        } catch (error: any) {
            dispatch(hasError(error));
        }

    }
}

export const getUserMasterApi = (filters:any) => {
    const body:any ={
        email:filters?.email?.trim() || '',
        role:filters?.role?.value || ''
    }
    return async (dispatch: any) => {
        dispatch(startLoading());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GET_USERS,
                body,
                false
            ).then(async (res: any) => {
                if (res !== null && res?.length > 0) {
                    dispatch(handleStoreUserMasterData(res));
                }
                else{
                    dispatch(handleStoreUserMasterData([]));
                }
            }, (err: any) => {
                toast.error(err.data);
                dispatch(stopLoading());
                dispatch(handleStoreUserMasterData([]));
            })
        } catch (error: any) {
            dispatch(hasError(error));
        }

    }
}

export const updateUserApi = (data: any, email: string, initRoleName: string) => {
    const body = {
        groupName: initRoleName,
        email: email,
        enabled: data?.grdsStatus == 'Active' ? true : data?.grdsStatus == 'Inactive' && false,
        newGroupName: data?.grdsStatus == 'Active' ? data?.role : data?.grdsStatus == 'Inactive' && initRoleName
    }
    return async (dispatch: any) => {
        dispatch(startLoading());
        try {
            await ServicesManagerAPICall.request(
                method.PUT,
                paths.UPDATE_USER,
                body,
                false
            ).then(async (res: any) => {
                if (res !== null && res.response === 'updated Successfully') {
                    dispatch(handleStoreUpdateUserResponse(res));
                    toast.success('User details updated successfully');
                }
                else{
                    toast.error('Failed to update user details');
                    dispatch(handleStoreUpdateUserResponse({}));
                }
            }, (err: any) => {
                toast.error(err.data);
                dispatch(stopLoading());
                dispatch(handleStoreUpdateUserResponse({}));
                toast.error('Failed to update user details');
            })
        } catch (error: any) {
            console.log(error);
            dispatch(hasError(error));
        }

    }
}


export const getAllUsersByDepartment = (department: any) => {
    let body = {
        name: department
    }
    return async (dispatch: any) => {
        dispatch(startLoading());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GET_USERS_BY_DEPARTMENT,
                body,
                false
            ).then(async (res: any) => {
                if (res !== null && res?.length > 0) {
                    dispatch(handleStoreUserListByDepartment(res));
                }
                else {
                    dispatch(handleStoreUserListByDepartment([]));
                }
            }, (err: any) => {
                toast.error(err.data);
                dispatch(stopLoading());
                dispatch(handleStoreUserListByDepartment([]));
            })
        } catch (error: any) {
            console.log(error);
            dispatch(hasError(error));
        }

    }
}



export const getAllRoles = () => {
    return async (dispatch: any) => {
        dispatch(startLoading());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GET_ALL_ROLES,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null && res?.length > 0) {
                    dispatch(handleStoreAllRoles(res));
                }
                else{
                    dispatch(handleStoreAllRoles([]));
                }
            }, (err: any) => {
                toast.error(err.data);
                dispatch(stopLoading());
                dispatch(handleStoreAllRoles([]));
            })
        } catch (error: any) {
            console.log(error);
            dispatch(hasError(error));
        }

    }
}


export const getPermissionsByRole = (groupName: string) => {
    let body = {
        groupName: groupName,
    }
    return async (dispatch: any) => {
        dispatch(startLoading());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GET_PERMISSIONS_BY_DEPARTMENT,
                body,
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleStoreGroupRoles(res));
                }
                else{
                    dispatch(handleStoreGroupRoles([]));
                }
            }, (err: any) => {
                toast.error(err.data);
                dispatch(stopLoading());
                dispatch(handleStoreGroupRoles([]));
            })
        } catch (error: any) {
            console.log(error);
            dispatch(hasError(error));
        }

    }
}


export const updateRolePermissions = (data: any, status: string | undefined, name: string, lineOfBusiness: any) => {
    let body = {
        grievanceDepartment:{
            department: name,
            status: status === 'Active' ? true : 
                status === 'Inactive' ? false : '',
        },
        permissionNames: data,
        lobId: mapLOBMaster(lineOfBusiness) ?? ''
    }
    return async (dispatch: any) => {
        dispatch(startLoading());
        try {
            await ServicesManagerAPICall.request(
                method.PUT,
                paths.UPDATE_ROLE_PERMISSIONS,
                body,
                false
            ).then(async (res: any) => {
                if (res !== null && res.response === 'created') {
                    toast.success('Role Updated Successfully');
                    dispatch(handleStoreUpdateRoleRes(res));
                }
                else{
                    toast.error('Unable to update role');
                    dispatch(handleStoreUpdateRoleRes([]));
                }
            }, (err: any) => {
                toast.error(err.data);
                dispatch(stopLoading());
                dispatch(handleStoreUpdateRoleRes([]));
            })
        } catch (error: any) {
            console.log(error);
            dispatch(hasError(error));
        }

    }
}

export const createRolePermissions = (permissions: any, data: any) => {
    let body = {
        name: data?.roleName?.trim(),
        description: data?.roleDescription?.trim(),
        status: data?.roleStatus === 'Active' ? true : 
                data?.roleStatus === 'Inactive' ? false : '',
        lobId:mapLOBMaster(data?.lineOfBusiness),
        permissionName: permissions
    }
    return async (dispatch: any) => {
        dispatch(startLoading());
        try {
            await ServicesManagerAPICall.request(
                method.POST,
                paths.CREATE_ROLE_PERMISSIONS,
                body,
                false
            ).then(async (res: any) => {
                if (res !== null && res.response === 'created') {
                    toast.success('Role Created Successfully');
                    dispatch(handleStoreCreateRoleRes(res));
                }
                else{
                    toast.error('Unable to create role');
                    dispatch(handleStoreCreateRoleRes([]));
                }
            }, (err: any) => {
                toast.error(err.data);
                dispatch(stopLoading());
                dispatch(handleStoreCreateRoleRes([]));
            })
        } catch (error: any) {
            console.log(error);
            dispatch(hasError(error));
        }

    }
}


export const getActiveSessions = (roleName: string) => {
    return async (dispatch: any) => {
        dispatch(startLoading());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.SESSION_GROUP + `/${roleName}` + paths.SESSION,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null && res.length > 0) {
                    dispatch(handleStoreActiveSessions(res));
                }
                else{
                    dispatch(handleStoreActiveSessions([]));
                }
            }, (err: any) => {
                toast.error(err.data);
                dispatch(stopLoading());
                dispatch(handleStoreActiveSessions([]));
            })
        } catch (error: any) {
            console.log(error);
            dispatch(hasError(error));
        }

    }
}

export const deleteRoleApi = (groupName: any, groupId:any ) => {
    return async (dispatch:any) => {
      let body = {  
        groupName:groupName,
        groupId:groupId
      }
        try {
            await ServicesManagerAPICall.request(
                method.DELETE,
                paths.DELETE_ROLE,
                body,
                false
            ).then(async (res: any) => {
                if (res !== null && res['RESPONSE'] === 'deleted') {
                    toast.success("Role deleted successfully!")
                }
                dispatch(handleStoreDeleteRoleRes(res));
            }, (err: any) => {
                toast(err.data)
                dispatch(stopLoading());
                dispatch(handleStoreDeleteRoleRes({}));
            })
        } catch (error: any) {
            console.log(error);
            dispatch(hasError(error));
        }

    }

}

export const deleteUserApi = (userId:any ) => {
    return async (dispatch:any) => {
      let body = {  
        userId : userId,
      }
        try {
            await ServicesManagerAPICall.request(
                method.DELETE,
                paths.DELETE_USER,
                body,
                false
            ).then(async (res: any) => {
                if (res !== null && res?.response === 'deleted') {
                    dispatch(handleStoreDeleteUserRes(res));
                    toast.success('User deleted successfully!');
                }
                else{
                    dispatch(handleStoreDeleteUserRes([]));
                    toast.error('User deletion failed. Please try again.');
                }
            }, (err: any) => {
                toast(err.data || 'Error occurred while deleting user.')
                dispatch(stopLoading());
                dispatch(handleStoreDeleteUserRes([]));
            })
        } catch (error: any) {
            console.log(error);
            toast.error('Unexpected error occurred.');
            dispatch(hasError(error));
        }

    }

}

export const editRoleApi = (
    currentGroupName: string,
    newGroupName: string,
    newDescription: string,
    groupId: string
) => {
    const body = {
        queryParams: {
            currentGroupName: currentGroupName,
            newGroupName: newGroupName,
            newDescription: newDescription?.trim(),
            groupId: groupId
        }
    };
 
    return async (dispatch: any) => {
        dispatch(startLoading());
        try {
            await ServicesManagerAPICall.request(
                method.PUT,
                paths.EDIT_USER,
                body,
                false
            ).then(
                async (res: any) => {
                    console.log(res);
                    
                    if (res !== null && res.response === 'updated Successfully') {
                        dispatch(handleStoreEditRoleRes(res));
                        toast.success('Role details edited successfully');
                    } else {
                        toast.error('Failed to edit Role details');
                        dispatch(handleStoreEditRoleRes({}));
                    }
                },
                (err: any) => {
                    toast(err.data);
                    dispatch(stopLoading());
                    dispatch(handleStoreEditRoleRes({}));
                    toast('Failed to edit role details');
                }
            );
        } catch (error: any) {
            console.log(error);
            dispatch(hasError(error));
        }
    };
};
